import PullToRefresh from 'pulltorefreshjs';
import globals from '@/util/globals';

const seachContentElement = () => globals.querySelector('.content');

export default {
    inserted(el, options) {
        let contentElement = seachContentElement();
        return PullToRefresh.init({
            mainElement: '.content',
            triggerElement: '.content',
            instructionsPullToRefresh: window.i18n.t('Pull down to refresh'),
            instructionsReleaseToRefresh: window.i18n.t('Release to refresh'),
            instructionsRefreshing: window.i18n.t('Refreshing'),
            onRefresh() {
                if (!options.value || typeof options.value !== 'function') return globals.location.reload();
                return options.value();
            },
            shouldPullToRefresh() {
                if (contentElement) return contentElement.scrollTop === 0;
                contentElement = seachContentElement();
                return !globals.scrollY;
            },
        });
    },
    unbind() {
        PullToRefresh.destroyAll();
    },
};
